<template>
    <form @submit.prevent="onSubmit()" @keydown="form.$errors.clear($event.target.name);">
        <div class="card card-form">
            <div class="row no-gutters">
                <div class="col-xl-4 col-md-6 p-3">
                    <b-form-group :label="$t('[[[Aktualne hasło]]]')" :feedback="form.$errors.first('currentPassword')" :state="form.$errors.state('currentPassword')" v-required>
                        <b-form-input v-model="form.currentPassword" type="password" name="currentPassword" autocomplete="off" v-focus></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('[[[Nowe hasło]]]')" :feedback="form.$errors.first('newPassword')" :state="form.$errors.state('newPassword')" v-required>
                        <b-form-input v-model="form.newPassword" type="password" name="newPassword" autocomplete="off"></b-form-input>
                    </b-form-group>
                    <b-form-group class="mb-0" :label="$t('[[[Powtórz hasło]]]')" :feedback="form.$errors.first('repeatPassword')" :state="form.$errors.state('repeatPassword')" v-required>
                        <b-form-input v-model="form.repeatPassword" type="password" name="repeatPassword" autocomplete="off"></b-form-input>
                    </b-form-group>
                </div>
            </div>
            <!-- Przyciski -->
            <div class="card-footer">
                <responsive>
                    <button type="submit" class="btn btn-primary" :disabled="form.disabled()">
                        <i class="fas fa-check"></i> {{ $t('[[[Zapisz]]]') }}
                    </button>
                    <router-link class="btn btn-light ml-2" :to="{name:'home'}">
                        <i class="far fa-arrow-alt-circle-left"></i> {{ $t('[[[Powrót]]]') }}
                    </router-link>
                </responsive>
            </div>
        </div>
    </form>
</template>

<script>
import Form from '@/helpers/Form';
import AuthService from '@/services/core/AuthService';

export default
{
    data: function()
    {
        return {
            form: Form.create({
                currentPassword: '',
                newPassword: '',
                repeatPassword: ''
            })
        };
    },

    methods: {
        async onSubmit()
        {
            try
            {
                this.form.disable();

                await AuthService.changePassword(this.form.data());

                this.form.enable();
                this.$alert.success(this.$t('[[[Hasło zostało zmienione.]]]'));
            }
            catch (ex)
            {
                this.form.enable();

                if (ex.code === 400)
                    this.$alert.warning(ex.message);

                if (ex.code === 422)
                    this.form.$errors.record(ex.data.errors);

                this.$log.debug(ex);
            }
        }
    }
};
</script>
